import { TextField } from "@mui/material"
import { useState, useEffect } from "react"

export default function InputNumber({
	label,
	value,
	setValue,
	startAdornment,
	disabled = false,
	fullWidth = true,
	isInt = false,
	size = "medium",
	onChange,
}) {
	// Mantiene el texto EXACTO que escribe el usuario
	const [text, setText] = useState(String(value ?? ""))
	const regex = isInt ? /^-?\d*$/ : /^-?\d*\.?\d*$/
	const handleChange = (event) => {
		const raw = event.target.value
		if (!regex.test(raw)) return
		setText(raw)
		const num = convertToNumber(raw, isInt)
		if (typeof setValue === "function") {
			setValue(num)
		} else if (typeof onChange === "function") {
			onChange(event)
		}
	}

	useEffect(() => {
		if (value === "" || value === null || typeof value === "undefined") {
			setText("")
		} else {
			setText(String(value))
		}
	}, [value])

	return (
		<TextField
			label={label}
			fullWidth={fullWidth}
			disabled={disabled}
			value={text}
			size={size}
			autoComplete="off"
			onChange={handleChange}
			InputProps={{
				startAdornment,
				inputMode: "numeric",
			}}
		/>
	)
}

function convertToNumber(raw, isInt) {
	// Casos donde NO hay número todavía
	if (raw === "" || raw === "-" || raw === "." || raw === "-.") {
		return null
	}
	let n = Number(raw)
	if (isInt) n = parseInt(raw)
	return isNaN(n) ? null : n
}
